import React from 'react';
import { CheckCircle2, AlertTriangle, XCircle, HelpCircle, Clock, PauseCircle, Sparkles, MinusCircle } from 'lucide-react';
import { Badge } from './Badge';
import { useT } from '../i18n/I18nProvider';

// Статусы предметной области: цвет + иконка + подпись (никогда только цвет)
const KINDS = {
  company: {
    active: { tone: 'success', icon: CheckCircle2 },
    trial: { tone: 'brand', icon: Sparkles },
    past_due: { tone: 'warning', icon: Clock },
    suspended: { tone: 'danger', icon: PauseCircle },
  },
  pos: {
    ok: { tone: 'success', icon: CheckCircle2 },
    error: { tone: 'danger', icon: XCircle },
    degraded: { tone: 'warning', icon: AlertTriangle },
    unconfigured: { tone: 'warning', icon: AlertTriangle },
    unknown: { tone: 'neutral', icon: HelpCircle },
  },
  billing: {
    ok: { tone: 'success', icon: CheckCircle2 },
    due_soon: { tone: 'warning', icon: Clock },
    overdue: { tone: 'danger', icon: AlertTriangle },
    none: { tone: 'neutral', icon: MinusCircle },
  },
};

export function StatusBadge({ kind, value, children }) {
  const t = useT();
  const spec = KINDS[kind]?.[value] ?? { tone: 'neutral', icon: HelpCircle };
  const Icon = spec.icon;
  return (
    <Badge tone={spec.tone}>
      <Icon className="h-3.5 w-3.5" aria-hidden="true" />
      {children ?? t(`status.${kind}.${value}`)}
    </Badge>
  );
}
